module.exports = __webpack_public_path__ + "img/fab.c18104b9.gif";